/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalframe_Group_InfoInputs */

const en_portalframe_group_info = /** @type {(inputs: Portalframe_Group_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reports and plans`)
};

/** @type {(inputs: Portalframe_Group_InfoInputs) => LocalizedString} */
const ar_portalframe_group_info = en_portalframe_group_info;

/** @type {(inputs: Portalframe_Group_InfoInputs) => LocalizedString} */
const he_portalframe_group_info = en_portalframe_group_info;

/** @type {(inputs: Portalframe_Group_InfoInputs) => LocalizedString} */
const ur_portalframe_group_info = en_portalframe_group_info;

/** @type {(inputs: Portalframe_Group_InfoInputs) => LocalizedString} */
const es_portalframe_group_info = en_portalframe_group_info;

/** @type {(inputs: Portalframe_Group_InfoInputs) => LocalizedString} */
const fr_portalframe_group_info = en_portalframe_group_info;

/** @type {(inputs: Portalframe_Group_InfoInputs) => LocalizedString} */
const de_portalframe_group_info = en_portalframe_group_info;

/** @type {(inputs: Portalframe_Group_InfoInputs) => LocalizedString} */
const pt_portalframe_group_info = en_portalframe_group_info;

/** @type {(inputs: Portalframe_Group_InfoInputs) => LocalizedString} */
const hi_portalframe_group_info = en_portalframe_group_info;

/** @type {(inputs: Portalframe_Group_InfoInputs) => LocalizedString} */
const bn_portalframe_group_info = en_portalframe_group_info;

/**
* | output |
* | --- |
* | "Reports and plans" |
*
* @param {Portalframe_Group_InfoInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalframe_group_info = /** @type {((inputs?: Portalframe_Group_InfoInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalframe_Group_InfoInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalframe_group_info(inputs)
	if (locale === "he") return he_portalframe_group_info(inputs)
	if (locale === "ur") return ur_portalframe_group_info(inputs)
	if (locale === "es") return es_portalframe_group_info(inputs)
	if (locale === "fr") return fr_portalframe_group_info(inputs)
	if (locale === "de") return de_portalframe_group_info(inputs)
	if (locale === "pt") return pt_portalframe_group_info(inputs)
	if (locale === "hi") return hi_portalframe_group_info(inputs)
	if (locale === "bn") return bn_portalframe_group_info(inputs)
	return /** @type {LocalizedString} */ ("Reports and plans")
});